import * as angular from 'angular';
import { DATES } from 'app/_constants/dates.constant';
import { bind } from 'app/_decorators/bind.decorator';
import { AuctionResource } from 'app/_resources/auction.resource';
import { AuctionsOverviewService } from 'app/_services/auctions-overview.service';

class PkpAuctionCalendarComponentCtrl implements ng.IController {
    public PERIOD_TYPE;
    public uiCalendarIsEmpty: boolean;
    public uiCalendarLoading: boolean;
    public uiErrorLoadingCalendar: boolean;
    public selectedPeriodType: any = {};
    public auctions: { [key: string]: AuctionCalendarDto[] };
    public colFiltOpts: any = {};
    public orderBy = 'publishDate';
    public reverseOrder = false;
    public minDate = new Date();

    constructor(
        private auctionResource: AuctionResource,
        private auctionsOverviewService: AuctionsOverviewService,
        private DATES: DATES
    ) {
        this.PERIOD_TYPE = this.auctionsOverviewService.PERIOD_TYPE;
    }

    $onInit(): void {
        this.auctionResource.calendars(
            (res: { [key: string]: AuctionCalendarDto[] }) => {
                var firstPeriodTypeToContainAuctions =
                    this.auctionsOverviewService.firstPeriodTypeToContainAuctions(
                        res
                    );
                if (!firstPeriodTypeToContainAuctions) {
                    this.uiCalendarIsEmpty = true;
                } else {
                    this.selectedPeriodType = firstPeriodTypeToContainAuctions;
                    this.auctions = res;
                }
                this.uiCalendarLoading = false;
            },
            (err: any) => {
                this.uiCalendarLoading = false;
                this.uiErrorLoadingCalendar = true;
            }
        );
    }

    public selectPeriodType(periodType) {
        if (
            !this.auctions[periodType.VALUE] ||
            !this.auctions[periodType.VALUE].length
        ) {
            return;
        }
        this.selectedPeriodType = periodType;
    }

    public isPeriodTypeSelected(periodType) {
        return this.selectedPeriodType === periodType;
    }

    public isLongTermSelected() {
        return this.auctionsOverviewService.isLongTermAuction(
            this.selectedPeriodType
        );
    }

    public isPeriodTypeAvailableInAuctions(periodType) {
        if (
            angular.isUndefined(this.auctions[periodType.VALUE]) ||
            this.auctions[periodType.VALUE] === null
        ) {
            return false;
        }
        return !!this.auctions[periodType.VALUE].length;
    }

    public getTitleForPeriodTypeSelector(periodType) {
        var periodTypeNormalizedLowerCase = periodType.NORMALIZED.toLowerCase();
        var title = '';
        if (angular.isUndefined(this.auctions[periodType.VALUE])) {
            title =
                'There are no ' +
                periodTypeNormalizedLowerCase +
                ' auctions available.';
            return title;
        }

        var numberOfAuctionsForPeriodType =
            this.auctions[periodType.VALUE].length || false;
        var informationString =
            numberOfAuctionsForPeriodType + ' ' + periodTypeNormalizedLowerCase;

        if (numberOfAuctionsForPeriodType < 2) {
            title = 'There is ' + informationString + ' auction available.';
        } else {
            title = 'There are ' + informationString + ' auctions available.';
        }

        return title;
    }

    public auctionHasAlreadyStarted(submissionEndBundled: string) {
        return Date.parse(submissionEndBundled) < Date.now();
    }

    @bind
    public filterByColumnFilter(value) {
        if (this.colFiltOpts.publicationDate) {
            var filterPublicationDate = new Date(
                this.colFiltOpts.publicationDate
            ).toDateString();
            var publicationDate = new Date(value.publishDate).toDateString();

            if (filterPublicationDate !== publicationDate) {
                return false;
            }
        }
        if (this.colFiltOpts.auctionStart) {
            var filterAuctionStart = new Date(
                this.colFiltOpts.auctionStart
            ).toDateString();
            var openDate = new Date(value.openDate).toDateString();

            if (filterAuctionStart !== openDate) {
                return false;
            }
        }
        if (this.colFiltOpts.capacityCategory) {
            if (this.colFiltOpts.capacityCategory !== '' + value.slot) {
                return false;
            }
        }
        if (this.colFiltOpts.productRuntime) {
            var filterProductRuntimeStart = new Date(
                this.colFiltOpts.productRuntime.start
            ).getTime();
            var filterProductRuntimeEnd = new Date(
                this.colFiltOpts.productRuntime.end
            ).getTime();
            var productRuntimeStart = new Date(value.runtime.start).getTime();
            var productRuntimeEnd = new Date(value.runtime.end).getTime();

            if (
                productRuntimeStart < filterProductRuntimeStart ||
                productRuntimeEnd > filterProductRuntimeEnd
            ) {
                return false;
            }
        }
        return true;
    }
}

angular.module('app').component('pkpAuctionCalendar', {
    controller: PkpAuctionCalendarComponentCtrl,
    controllerAs: 'auctionCalendar',
    template: require('app/auction-calendar/auction-calendar.component.html'),
    bindings: {
        displayUploadBtn: '<'
    }
});
